import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { collection, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { Activity } from "./activity.type";

const DEFAULT_COUNT = 6;

export const ActivityApi = createApi({
  reducerPath: "activityApi",
  tagTypes: ["activities"],
  baseQuery: fakeBaseQuery(),
  endpoints: (builder) => ({
    getLatestActivities: builder.query({
      queryFn: async () => ({ data: [] as Activity[] }),

      async onCacheEntryAdded(
        count: number | undefined,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
        let unsubscribe: (() => void) | undefined;

        try {
          await cacheDataLoaded;

          const q = query(
            collection(db, "activities"),
            orderBy("timestamp", "desc"),
            limit(count || DEFAULT_COUNT),
          );

          unsubscribe = onSnapshot(
            q,
            (snapshot) => {
              const activities = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
              })) as Activity[];

              updateCachedData(() => activities);
            },
            (error) => {
              console.error("Erreur onSnapshot activities:", error);
            }
          );
        } catch (error) {
          console.error("Erreur de souscription:", error);
        }

        await cacheEntryRemoved;
        unsubscribe?.();
      },
      providesTags: ["activities"],
    }),
  }),
});

export const { 
  useGetLatestActivitiesQuery,
} = ActivityApi;
